export default function SupplyChainSection() {
  return (
    <section id="supply" className="bg-white py-12 px-6 border-t border-[#E2E8F0]">
      <div className="max-w-7xl mx-auto">
        <div className="mb-8">
          <p
            className="text-xs font-semibold tracking-widest uppercase text-[#2563EB] mb-1"
            style={{ fontFamily: 'Inter, sans-serif' }}
          >
            Procurement &amp; Manufacturing
          </p>
          <h2
            className="text-[#0F172A] text-3xl xl:text-4xl leading-tight"
            style={{ fontFamily: 'Inter, sans-serif', fontWeight: 800, letterSpacing: '-0.05em' }}
          >
            Supply Chain Solutions
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* Left */}
          <div className="bg-[#F8F9FA] border border-[#E2E8F0] rounded-lg p-6 flex flex-col gap-4">
            <div className="flex items-center gap-3">
              <div className="w-9 h-9 flex items-center justify-center rounded-md bg-[#0F172A]">
                <i className="ri-archive-line text-white text-base"></i>
              </div>
              <div>
                <p
                  className="text-xs font-semibold tracking-widest uppercase text-[#475569]"
                  style={{ fontFamily: 'Inter, sans-serif' }}
                >
                  Option 01
                </p>
                <h3
                  className="text-[#0F172A] text-xl"
                  style={{ fontFamily: 'Inter, sans-serif', fontWeight: 800, letterSpacing: '-0.04em' }}
                >
                  Raw Material Supply
                </h3>
              </div>
            </div>

            <p className="text-sm text-[#475569] leading-relaxed" style={{ fontFamily: 'Inter, sans-serif' }}>
              Bulk, standardized supply for independent manufacturing facilities. Foraged Fuel provides
              kilogram-scale Cordymax™ raw material with full documentation — COAs, MSDS, and customs
              declarations included — enabling seamless drop-in to your existing production line.
            </p>

            <ul className="flex flex-col gap-2 mt-1">
              {[
                'Minimum order quantities available',
                'Flexible concentration tiers: 1%, 2%, 5%, 7.5%, and 10%.',
                'Bulk, drum, and kilo-pack configurations',
                'Full technical documentation on delivery',
              ].map((item) => (
                <li key={item} className="flex items-start gap-2">
                  <div className="w-4 h-4 flex items-center justify-center shrink-0 mt-0.5">
                    <i className="ri-checkbox-circle-line text-[#2563EB] text-sm"></i>
                  </div>
                  <span className="text-sm text-[#475569]" style={{ fontFamily: 'Inter, sans-serif' }}>
                    {item}
                  </span>
                </li>
              ))}
            </ul>

            <a
              href="tel:9548655411"
              className="mt-auto self-start border border-[#0F172A] text-[#0F172A] text-sm font-semibold px-5 py-2.5 rounded-md hover:bg-[#0F172A] hover:text-white transition-colors whitespace-nowrap cursor-pointer"
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              Request Bulk Pricing
            </a>
          </div>

          {/* Right */}
          <div className="bg-[#0F172A] border border-[#0F172A] rounded-lg p-6 flex flex-col gap-4">
            <div className="flex items-center gap-3">
              <div className="w-9 h-9 flex items-center justify-center rounded-md bg-white/10 border border-white/20">
                <i className="ri-box-3-line text-white text-base"></i>
              </div>
              <div>
                <p
                  className="text-xs font-semibold tracking-widest uppercase text-[#94a3b8]"
                  style={{ fontFamily: 'Inter, sans-serif' }}
                >
                  Option 02
                </p>
                <h3
                  className="text-white text-xl"
                  style={{ fontFamily: 'Inter, sans-serif', fontWeight: 800, letterSpacing: '-0.04em' }}
                >
                  Turnkey Production
                </h3>
              </div>
            </div>

            <p className="text-sm text-[#94a3b8] leading-relaxed" style={{ fontFamily: 'Inter, sans-serif' }}>
              End-to-end D2C manufacturing and white-labeling for rapid market entry. We handle
              formulation, encapsulation or powder blending, packaging design, label compliance, and
              fulfillment logistics — so your brand launches faster with zero capital overhead.
            </p>

            <ul className="flex flex-col gap-2 mt-1">
              {[
                'D2C-ready SKU development in 6–10 weeks',
                'Custom private label packaging available',
                'Pre-formulated performance blends with Cordymax™',
                'FDA facility, GMP certified co-manufacturer',
              ].map((item) => (
                <li key={item} className="flex items-start gap-2">
                  <div className="w-4 h-4 flex items-center justify-center shrink-0 mt-0.5">
                    <i className="ri-checkbox-circle-line text-[#2563EB] text-sm"></i>
                  </div>
                  <span className="text-sm text-[#94a3b8]" style={{ fontFamily: 'Inter, sans-serif' }}>
                    {item}
                  </span>
                </li>
              ))}
            </ul>

            <a
              href="tel:9548655411"
              className="mt-auto self-start bg-white text-[#0F172A] text-sm font-semibold px-5 py-2.5 rounded-md hover:bg-[#F8F9FA] transition-colors whitespace-nowrap cursor-pointer"
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              Discuss Turnkey Options
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
